import React from 'react';

import { FlexColumn } from 'ui-components/components/flex';
import { Divider } from 'ui-components/components/divider';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { useEntitiesFulfillmentPlan } from '../../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useCreateAmountSummary } from '../edit-amount-summary/use-edit-amount-summary';
import { AmountSummaryRow } from './amount-summary-row';
import { CountryConfigNames } from '../../../../../../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../../../../../../hooks/use-country-config';

import { useDutiesInAmountSummary } from '../../../../../../../feature-flags/hooks/use-duties-in-amount-summary';

import messages from '../messages';
import style from '../style.module.less';

export const ReadOnlyAmountSummary = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const {
    amountSummary = emptyObject,
    items = emptyArray,
    international = emptyObject,
  } = useEntitiesFulfillmentPlan(fulfillmentPlanId) || emptyObject;

  const isDutiesInAmountSummaryEnabled = useDutiesInAmountSummary();

  const [isTaxesIncludedInOrdersTotal] = useCountryConfig(CountryConfigNames.TaxesIncludedInOrdersTotal);

  const { productAmount, shippingAmount, taxAmount, totalAmount, totalPaidAmount, dutiesTotalAmount, isDutiesTotalNull } =
    useCreateAmountSummary(fulfillmentPlanId, amountSummary, items, isTaxesIncludedInOrdersTotal);

  return (
    <FlexColumn className={style['amount-summary']}>
      <AmountSummaryRow currency={productAmount} labelMessage={messages.productCost} />
      <AmountSummaryRow currency={shippingAmount} labelMessage={messages.shippingCost} />
      <AmountSummaryRow currency={taxAmount} labelMessage={messages.taxAmount} />
      {isDutiesInAmountSummaryEnabled && international.isInternational && !isDutiesTotalNull && (
        <AmountSummaryRow
          currency={dutiesTotalAmount}
          hideValueWhenZero
          labelMessage={messages.dutiesTotalAmount}
          toolTipMessage={dutiesTotalAmount ? messages.dutiesTotalAmountTooltip : undefined}
        />
      )}
      <Divider className={style['amount-summary-row-divider']} orientation='horizontal' />
      <AmountSummaryRow
        currency={totalAmount}
        labelMessage={messages.totalAmount}
        toolTipMessage={isTaxesIncludedInOrdersTotal ? messages.totalTaxesInclusiveTooltip : undefined}
      />
      <AmountSummaryRow currency={totalPaidAmount} labelMessage={messages.totalPaid} toolTipMessage={messages.totalPaidTooltip} />
    </FlexColumn>
  );
};
